import { useState, useContext, useRef } from "react";
import { ApiContext } from '../../App';
import { toast } from "react-toastify";
import RichTextEditor from '../common/RichTextEditor';


const AddTemplateForm = ({ onTemplateAdded, onClose }) => {
  const API = useContext(ApiContext);
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState("");
  const [loading, setLoading] = useState(false);
  const quillRef = useRef(null);

  const insertField = (field) => {
    const textToInsert = `{{${field}}}`;
    // Insérer à la fin du contenu actuel
    setBody(prevBody => prevBody + textToInsert + " ");
  };

  const handleAddTag = () => {
    if (tagInput.trim() && !tags.includes(tagInput.trim().toLowerCase())) {
      setTags([...tags, tagInput.trim().toLowerCase()]);
      setTagInput("");
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    setTags(tags.filter(tag => tag !== tagToRemove));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await API.post("/api/templates", { name, subject, body, tags });
      toast.success("Template ajouté avec succès !");
      onTemplateAdded();
      onClose();
    } catch (error) {
      console.error("Erreur lors de l'ajout du template :", error);
      toast.error("Échec de l'ajout du template.");
    }
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
      <div>
        <label className="block text-xs sm:text-sm font-medium text-slate-700 mb-1">
          Nom du Template
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          className="w-full border p-2 sm:p-2.5 rounded focus:ring-2 focus:ring-indigo-500 text-sm sm:text-base"
          placeholder="ex: Premier contact"
        />
      </div>

      <div>
        <label className="block text-xs sm:text-sm font-medium text-slate-700 mb-1">
          Objet
        </label>
        <input
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          required
          className="w-full border p-2 sm:p-2.5 rounded focus:ring-2 focus:ring-indigo-500 text-sm sm:text-base"
          placeholder="ex: Opportunité professionnelle"
        />
      </div>

      <div>
        <label className="block text-xs sm:text-sm font-medium text-slate-700 mb-2">
          Champs Dynamiques
        </label>
        <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-1.5 sm:gap-2">
          <button
            type="button"
            onClick={() => insertField("Name")}
            className="bg-indigo-100 text-indigo-700 px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm hover:bg-indigo-200 transition-colors"
          >
            Nom
          </button>
          <button
            type="button"
            onClick={() => insertField("company")}
            className="bg-indigo-100 text-indigo-700 px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm hover:bg-indigo-200 transition-colors"
          >
            Entreprise
          </button>
          <button
            type="button"
            onClick={() => insertField("jobTitle")}
            className="bg-indigo-100 text-indigo-700 px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm hover:bg-indigo-200 transition-colors"
          >
            Poste
          </button>
          <button
            type="button"
            onClick={() => insertField("city")}
            className="bg-indigo-100 text-indigo-700 px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm hover:bg-indigo-200 transition-colors"
          >
            Ville
          </button>
        </div>
        <p className="text-xs text-slate-500 mt-2">
          Cliquez sur un champ pour l'insérer dans le contenu
        </p>
      </div>

      <div>
        <label className="block text-xs sm:text-sm font-medium text-slate-700 mb-1">
          Tags (optionnel)
        </label>
        <div className="flex gap-2">
          <input
            type="text"
            value={tagInput}
            onChange={(e) => setTagInput(e.target.value)}
            onKeyDown={handleKeyPress}
            className="flex-1 border p-2 sm:p-2.5 rounded focus:ring-2 focus:ring-indigo-500 text-sm sm:text-base"
            placeholder="ex: recrutement, relance..."
          />
          <button
            type="button"
            onClick={handleAddTag}
            className="px-3 sm:px-4 py-2 bg-indigo-100 text-indigo-700 rounded hover:bg-indigo-200 transition-colors text-sm sm:text-base"
          >
            Ajouter
          </button>
        </div>
        {tags.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-2">
            {tags.map((tag, index) => (
              <span
                key={index}
                className="inline-flex items-center gap-1 bg-indigo-100 text-indigo-700 px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm"
              >
                {tag}
                <button
                  type="button"
                  onClick={() => handleRemoveTag(tag)}
                  className="hover:text-indigo-900"
                >
                  <i className="bi bi-x"></i>
                </button>
              </span>
            ))}
          </div>
        )}
        <p className="text-xs text-slate-500 mt-1">
          Les tags facilitent la recherche de templates
        </p>
      </div>

      <div>
        <label className="block text-xs sm:text-sm font-medium text-slate-700 mb-1">
          Contenu
        </label>
        <div className="border-1 border-gray-200 rounded-lg">
          <RichTextEditor
          value={body}
          onChange={setBody}
          placeholder="Bonjour {{Name}}, j'espère que vous allez bien..."
          minHeight="250px"
        />
        </div>
        
        <div className="mt-2 text-xs text-slate-500">
          <p>Variables disponibles : {"{{Name}}"}, {"{{company}}"}, {"{{jobTitle}}"}, {"{{city}}"}</p>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3 pt-3 sm:pt-4">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 border border-slate-300 rounded text-slate-600 hover:bg-gray-50 transition-colors text-sm sm:text-base order-2 sm:order-1"
        >
          Annuler
        </button>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 disabled:opacity-50 transition-colors text-sm sm:text-base order-1 sm:order-2"
        >
          {loading ? "Ajout..." : "Ajouter"}
        </button>
      </div>
    </form>
  );
};

export default AddTemplateForm;